import { render, staticRenderFns } from "./BuyxGety.vue?vue&type=template&id=06ec556e"
import script from "./BuyxGety.vue?vue&type=script&lang=js"
export * from "./BuyxGety.vue?vue&type=script&lang=js"
import style0 from "./BuyxGety.vue?vue&type=style&index=0&id=06ec556e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports